/*
  西班牙语（es）
*/
export default {
  promptText: {
    msg1: 'éxito',
    msg2: 'advertencia',
    msg3: 'error',
    msg4: 'Validación exitosa',
    msg5: 'Por favor agregue la tienda primero',
    msg6: 'Lo sentimos, el peso del pedido no puede exceder los 30 kg.',
    msg7: 'El stock actual de productos:',
    msg8: 'Establezca primero la dirección de la factura o pague por otros medios',
    msg9: 'No se puede enviar a la dirección de este almacén, cambie la dirección de envío o el almacén',
    msg10: '¡Agregue primero la información de la dirección!',
    msg11: '¡Error, límite de crédito alcanzado!',
    msg12: '¡Por favor agregue la dirección de envío!', // ？在哪里加
    msg13: '¡Seleccione una dirección de envío!',
    msg14: 'Por favor, introduzca su correo electrónico válido', // ？在哪里加  ❌
    msg15: 'El correo electrónico ya ha sido registrado.',
    msg16: 'Introduce el código de promoción',
    msg17: 'Falta información del artículo', // ？在哪里出现报错，什么原因 （找不到商品信息）
    msg18: 'Por favor ingrese la cantidad', // ？在哪里界面出现 请选择要添加进购物车的商品
    msg19: 'Bolsa de la compra añadida con éxito',
    msg20: 'No se pudo agregar la bolsa de compras', // ？为什么失败  在后端报错，在后端找原因
    msg21: 'Agregado al elemento favorito con éxito',
    msg22: 'Error de código de país', // 增加地址时的电话区号有误
    msg23: '¡Cambio de dirección con éxito!',
    msg24: 'Por favor dé su marca primero', // 商品评论的星星不能为空
    msg25: 'Correo electrónico verificado, restablezca su contraseña',
    msg26: 'Correo electronico (requerido', // 忘记密码时输入的邮箱
    msg27: 'La contraseña se ha restablecido, vuelva a iniciar sesión',
    msg28: 'Código de verificacion enviado',
    msg29: 'Ingrese su correo electrónico y nombre completo primero',
    msg30: 'Código de verificación incorrecto.', // 验证码有误
    msg31: '¡Gracias por tu presentación!',
    msg32: '¡Registro exitoso!',
    msg33: 'Hasta',
    msg34: '¡Correo electrónico/contraseña incorrectos!',
    msg35: '¡Por favor ingrese un número mayor que el número de inicio!', // 优化
    msg36: 'La imagen no puede exceder los 5 MB', // 以图搜图
    msg37: 'El número de seguimiento no puede estar vacío', // ❌
    msg38: 'KkOrderId no puede estar vacío', // ❌
    msg39: 'El transportista no puede estar vacío', // ❌
    msg40: 'Eliminar dirección con éxito',
    msg41: 'Por favor agregue la dirección de recepción primero',
    msg42: 'Por favor, elija la plataforma de su tienda al principio',
    msg43: 'Guardar la configuración de la tienda con éxito',
    msg44: 'La entrada es demasiado larga', // 标题过长
    msg45: 'El precio de comparación debe ser más alto que el precio sugerido',
    msg46: 'plataforma requerida',
    msg47: 'tienda requerida',
    msg48: 'Por favor ingrese primero su número de teléfono y nombre completo',
    msg49: 'Número de teléfono requerido', // 忘记密码时输入的手机号
    msg50: 'Consulte los términos de servicio en la parte inferior.'
  }
}

